"use client";
import cn from "clsx";
import { useRouter, usePathname } from "@/navigation";
import * as Select from "@radix-ui/react-select";
import { Flex } from "@radix-ui/themes";
import { Debug } from "@/util/debug";
import { appRouterPush } from "@/util/apputil";
import { defaultLocale } from "@/i18n/routing";
import { AlertContext } from "@/components/context/alertContext";
import { useContext } from "react";
import { alertOffline } from "../list/defaultType";
import { useTranslations } from "next-intl";
const data: { [key: string]: { name: string; nick: string } } = {
  ko: { name: "한국어", nick: "한" },
  en: { name: "English", nick: "EN" },
};

export default function LanguageChanger({ className, locale }: { className?: string; locale?: string }) {
  const router = useRouter();
  const pathname = usePathname();
  const ta = useTranslations("alert");
  const alertContext = useContext(AlertContext);

  const handleChange = (value: string) => {
    if (navigator.onLine) {
      appRouterPush(router, pathname, { locale: value });
    } else {
      const alert_p = alertContext.setProp; //params?.alertFunction;
      if (alert_p) {
        alert_p(alertOffline(ta));
      }
    }
  };
  const localeKey = Object.keys(data);
  const localeData = data[locale ?? defaultLocale];
  if (!localeData) {
    Debug("LanguageChanger", locale);
  }
  return (
    <Flex direction="column" className={cn(className, "text-right lg:min-w-16 text-lg")}>
      <Select.Root value={locale} onValueChange={handleChange} name="tool_language_button">
        <Select.Trigger className="outline-0 text-center" id="tool_language_button" aria-label="Tool Language Button">
          <Flex id="themeState" align="center" className="p-1 !block text-right group">
            <span className="hidden lg:block group-hover:animate-bounce group-hover:animate-infinite">{localeData?.name ?? "English"}</span>
            <span className="block lg:hidden group-hover:animate-bounce group-hover:animate-infinite">{localeData?.nick ?? "En"}</span>
          </Flex>
        </Select.Trigger>
        <Select.Content position="popper" className="bg-skin-fill text-right lg:min-w-16 mr-14 z-20">
          {localeKey.map((item, index) => {
            return (
              <Select.Item
                key={"locale_select_" + index}
                value={item}
                className={cn(locale == item ? "hidden" : "", "cursor-pointer mt-1 p-1 outline-amber-500 text-right lg:min-w-16 ")}
              >
                <span className="hidden lg:block">{data[item]?.name}</span>
                <span className="block lg:hidden">{data[item]?.nick}</span>
              </Select.Item>
            );
          })}
        </Select.Content>
      </Select.Root>
    </Flex>
  );
}
